import React from 'react';
import { motion } from 'motion/react';
import Tooltip from '@/components/Tooltip';

interface TechnologyItem {
  technology: string;
  name: string
  sci_fi_to_emerging?: string;
  emerging_to_exists?: string;
  symbol?: string; // SVG path for the symbol
}

interface TechnologyProgressionChartProps {
  currentSectionIndex: number;
  className?: string;
}

const technologies: TechnologyItem[] = [
  {
    technology: "画像を認識し分類するAI",
    sci_fi_to_emerging: "2010-01-01",
    emerging_to_exists: "2015-01-01",
    name: "画像認識"
  },
  {
    technology: "わずか2時間の練習でAtariのゲームをプレイできるようになるAI",
    sci_fi_to_emerging: "2015-01-01",
    emerging_to_exists: "2018-01-01",
    name: "Atari学習AI"
  },
  {
    technology: "英語のテキストを理解するAI",
    sci_fi_to_emerging: "2018-01-01",
    emerging_to_exists: "2020-01-01",
    name: "言語理解AI"
  },
  {
    technology: "詩や小説を書くAI",
    sci_fi_to_emerging: "2018-01-01",
    emerging_to_exists: "2020-01-01",
    name: "創作ライター"
  },
  {
    technology: "市街地を走行できる自動運転車",
    sci_fi_to_emerging: "2015-01-01",
    emerging_to_exists: "2024-01-01",
    symbol: 'cube',
    name: "ロボタクシー"
  },
  {
    technology: "画像を生成できるAI",
    sci_fi_to_emerging: "2018-01-01",
    emerging_to_exists: "2022-01-01",
    name: "画像生成AI"
  },
  {
    technology: "コードを理解するAI",
    sci_fi_to_emerging: "2020-01-01",
    emerging_to_exists: "2022-01-01",
    name: "コード理解AI"
  },
  {
    technology: "常識的な理解を備え、数百万のデイリーアクティブユーザーを持つほど有用な汎用チャットボットAI",
    sci_fi_to_emerging: "2020-01-01",
    emerging_to_exists: "2022-01-01",
    name: "対話AI"
  },
  {
    technology: "ほとんどの分野で博士号レベルの知識を持つ汎用チャットボットAI",
    sci_fi_to_emerging: "2022-01-01",
    emerging_to_exists: "2024-01-01",
    name: "専門家チャットボット"
  },
  {
    technology: "個人秘書として機能できる汎用エージェントAI",
    sci_fi_to_emerging: "2024-01-01",
    emerging_to_exists: "2025-11-01",
    name: "バーチャル秘書"
  },
  {
    technology: "知り合いの誰かがAIの恋人を持っている",
    sci_fi_to_emerging: "2024-01-01",
    emerging_to_exists: "2026-05-01",
    name: "AIの恋人"
  },
  {
    technology: "プロのプログラマーを完全に代替できるAI",
    sci_fi_to_emerging: "2024-01-01",
    emerging_to_exists: "2027-02-01",
    name: "AIプログラマー"
  },
  {
    technology: "AIの研究開発を完全に自動化できるAI",
    sci_fi_to_emerging: "2024-01-01",
    emerging_to_exists: "2027-06-01",
    name: "研究自動化AI"
  },
  {
    technology: "AGI：経済的に有用なほとんどの仕事で人間を上回れるAI",
    sci_fi_to_emerging: "2024-01-01",
    emerging_to_exists: "2027-10-01",
    name: "汎用知能"
  },
  {
    technology: "2020年代初頭の100倍の速さで進むAIの進歩",
    sci_fi_to_emerging: "2027-05-01",
    emerging_to_exists: "2027-12-01",
    name: "AI進歩の指数関数的成長"
  },
  {
    technology: "生物圏を破壊する鏡像生命",
    sci_fi_to_emerging: "2027-02-01",
    emerging_to_exists: "2035-01-01",
    symbol: 'infinity',
    name: "鏡像生命"
  },
  {
    technology: "超知能：身体を必要としないあらゆることで最高の人間を上回るAI",
    sci_fi_to_emerging: "2027-06-01",
    emerging_to_exists: "2027-12-01",
    name: "超知能"
  },
  {
    technology: "AIが発見したがんの治療法",
    sci_fi_to_emerging: "2027-07-01",
    emerging_to_exists: "2028-08-01",
    name: "がんの治療法"
  },
  {
    technology: "実際に役立つヒューマノイドロボット",
    sci_fi_to_emerging: "2027-08-01",
    emerging_to_exists: "2028-03-01",
    name: "ヒューマノイドロボット"
  },
  {
    technology: "インターネット上をハッキングして回る暴走AI",
    sci_fi_to_emerging: "2027-10-01",
    emerging_to_exists: "2028-05-01",
    symbol: "chip",
    name: "暴走ハッカー"
  },
  {
    technology: "完全に自給自足するロボット経済",
    sci_fi_to_emerging: "2028-01-01",
    emerging_to_exists: "2028-08-01",
    name: "ロボット経済"
  },
  {
    technology: "蚊ほどの大きさの殺人ドローン",
    sci_fi_to_emerging: "2028-03-01",
    emerging_to_exists: "2028-10-01",
    name: "蚊型ドローン"
  },
  {
    technology: "AIが発見した老化の治療法",
    sci_fi_to_emerging: "2028-02-01",
    emerging_to_exists: "2028-10-01",
    name: "老化の治療法"
  },
  {
    technology: "人間の脳のアップロードの成功",
    sci_fi_to_emerging: "2028-05-01",
    emerging_to_exists: "2028-11-01",
    symbol: "brain",
    name: "脳のアップロード"
  },
  {
    technology: "太陽エネルギーのかなりの部分を捕捉するダイソン群",
    sci_fi_to_emerging: "2028-07-01",
    emerging_to_exists: "2040-01-01",
    name: "ダイソン群"
  },
  {
    technology: "自律的に自己複製する人工ナノボット",
    sci_fi_to_emerging: "2028-10-01",
    emerging_to_exists: "2035-01-01",
    name: "ナノボット"
  },
];

const TechnologyProgressionChart = ({ currentDate, className }: { currentDate: Date, className: string }) => {

  const getCurrentCategory = (item: TechnologyItem) => {
    if (currentDate >= (item.emerging_to_exists ? new Date(item.emerging_to_exists) : new Date())) {
      return 'established';
    } else if (currentDate >= (item.sci_fi_to_emerging ? new Date(item.sci_fi_to_emerging) : new Date())) {
      return 'emerging';
    }
    return 'speculative';
  };

  const renderTechItem = (item: TechnologyItem, category: 'established' | 'emerging' | 'speculative') => (
    <Tooltip
      key={item.technology}
      content={
        <div className="w-64 font-sans p-2">
          <p className="text-xs mt-0 mb-2 font-bold">{item.name}</p>
          <p className="text-xs mt-0 mb-0">{item.technology}</p>
        </div>
      }
    >
      <motion.div
        layoutId={`tech-${item.technology}`}
        className={`relative w-[12px] h-[12px] flex items-center justify-center rounded-sm ${
          category === 'emerging' ? 'bg-[var(--accent)]' : 'bg-black'
        }`}
        transition={{
          layout: {
            duration: 0.5,
            ease: "linear"
          }
        }}
      >
        {item.symbol && (
          <div className="absolute w-[10px] h-[10px] flex items-center justify-center">
              {item.symbol === 'brain' && (
                <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100"
                className="w-full h-full"
                fill="white"
              >
                  <path d="M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z" />
                  <path d="M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z" />
                  <path d="M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z" />
                  <path d="M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z" />
                  <path d="M31,9.6c-0.3,0-0.6-0.1-0.9-0.1c-7.1,0-13,5.4-14.5,12.6c0.2,5,2.2,11.1,10,14.1c1,0.4,1.6,1.6,1.1,2.6     c-0.3,0.8-1.1,1.3-1.9,1.3c-0.2,0-0.5,0-0.7-0.1c-7.1-2.8-10.5-7.9-11.9-13.1c-3.2,2.3-5.4,6.2-5.4,10.7c0,3.6,1.4,6.9,3.6,9.2     c-1.5,2.2-2.3,5-2.3,7.9c0,3.2,1.1,6.1,2.8,8.4c1.6-4.2,4.8-8.2,11.1-9.8c1.1-0.3,2.2,0.4,2.5,1.5c0.3,1.1-0.4,2.2-1.5,2.5     c-6.3,1.6-8.4,6.2-9,9.9c0.1,7.3,4.1,13.4,9.8,16.4c0-0.1,0-0.3,0-0.4c0.2-5.1,4-8.1,7.7-8.9c4.2-0.9,8.1,0.9,9.9,4.7     c0.5,1,0.7,2,0.7,3c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-0.4-0.1-0.8-0.3-1.2c-1.2-2.4-3.6-2.9-5.4-2.5c-2.1,0.5-4.4,2.2-4.5,5.1     c-0.1,1.7,0.2,3.3,0.6,4.8c2.3,5.5,7.4,9.4,13.3,9.4c2.3,0,4.5-0.6,6.4-1.7V4.5c-1.9-1.3-4-2-6.4-2C36.9,2.5,32.9,5.4,31,9.6z      M25.5,22.7c0.2-1.1,1.3-1.8,2.4-1.6c0.2,0,3.1,0.7,6,3c2.5-3,1.6-7.1,1.6-7.1c-0.3-1.1,0.4-2.2,1.5-2.4c1.1-0.2,2.2,0.4,2.4,1.5     c0.1,0.3,1.4,6.5-2.8,11c0.2,0.2,0.3,0.4,0.5,0.6c2.4,3.7,3,8.4,1.7,13.9c-0.2,0.9-1,1.6-2,1.6c-0.1,0-0.3,0-0.4,0     c-1.1-0.2-1.8-1.3-1.5-2.4c1-4.4,0.6-8-1.2-10.8c-2.4-3.7-6.6-4.8-6.7-4.8C26,24.9,25.3,23.8,25.5,22.7z M29.9,65.9     c-0.1,0-0.2,0-0.3,0c-1,0-1.8-0.7-2-1.7c-0.2-1.1,0.6-2.1,1.7-2.3c0.8-0.1,7.4-1.6,7-9.4c-0.1-1.1,0.8-2.1,1.9-2.1     c1.1-0.1,2.1,0.8,2.1,1.9C40.8,61.6,33.7,65.2,29.9,65.9z" />
                  <path d="M93.3,37.6c0-4.5-2.2-8.4-5.4-10.7C86.5,32.1,83.1,37.2,76,40c-0.2,0.1-0.5,0.1-0.7,0.1c-0.8,0-1.6-0.5-1.9-1.3     c-0.4-1,0.1-2.2,1.1-2.6c7.7-3,9.8-9.1,10-14.1C83,14.9,77.1,9.5,70,9.5c-0.3,0-0.6,0.1-1,0.1c-2-4.2-6-7.1-10.6-7.1     c-2.4,0-4.5,0.8-6.4,2v91.3c1.9,1,4.1,1.7,6.4,1.7c5.9,0,11-3.9,13.3-9.4c0.4-1.5,0.7-3.1,0.7-4.8c-0.1-2.9-2.3-4.6-4.5-5.1     c-1.8-0.4-4.2,0.1-5.4,2.5c-0.2,0.4-0.3,0.8-0.3,1.2c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1,0.2-2,0.7-3c1.8-3.7,5.7-5.6,9.9-4.7     c3.7,0.8,7.5,3.8,7.7,8.9c0,0.1,0,0.3,0,0.4c5.7-3,9.6-9.1,9.8-16.3c-0.6-3.7-2.7-8.3-9-10c-1.1-0.3-1.7-1.4-1.5-2.5     c0.3-1.1,1.4-1.7,2.5-1.5c6.3,1.6,9.6,5.6,11.1,9.8c1.7-2.3,2.8-5.2,2.8-8.4c0-3-0.9-5.7-2.3-7.9C91.9,44.5,93.3,41.2,93.3,37.6z      M70.4,65.9c-0.1,0-0.2,0-0.3,0c-3.8-0.6-10.9-4.3-10.4-13.6c0.1-1.1,1-2,2.1-1.9c1.1,0.1,2,1,1.9,2.1c-0.4,7.9,6.3,9.3,7,9.4     c1.1,0.2,1.8,1.2,1.6,2.3C72.3,65.2,71.4,65.9,70.4,65.9z M67.7,28C67.7,28.1,67.7,28.1,67.7,28c-0.1,0.1-0.2,0.2-0.3,0.2     c-2.2,2.3-3.8,6.1-2.4,12.4c0.2,1.1-0.4,2.2-1.5,2.4c-0.1,0-0.3,0-0.4,0c-0.9,0-1.8-0.6-2-1.6c-1.2-5.5-0.6-10.2,1.7-13.9     c0.1-0.2,0.3-0.4,0.5-0.6c-4.2-4.5-2.8-10.7-2.8-11c0.3-1.1,1.3-1.8,2.4-1.5c1.1,0.3,1.8,1.3,1.5,2.4c0,0.2-0.9,4.2,1.6,7.1     c2.9-2.3,5.8-3,6-3c1.1-0.2,2.2,0.5,2.4,1.6c0.2,1.1-0.5,2.2-1.5,2.4C72.4,25.3,69.9,25.9,67.7,28z" />
                </svg>
              )}
              {item.symbol === 'infinity' && (
                <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100"
                className="w-full h-full"
                fill="white"
              >
                <path d="M70 40c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15s15-6.716 15-15c0-8.284-6.716-15-15-15zm-40 0c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15s15-6.716 15-15c0-8.284-6.716-15-15-15z" />
              </svg>
              )}
              {item.symbol === 'cube' && (
                <svg className="h-[8px] w-[8px]" fill="white" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                <path d="m1111.2 411.6h-74.398l-48-150c-25.199-76.801-96-128.4-176.4-128.4l-424.8-0.003906c-80.398 0-152.4 51.602-176.4 128.4l-48 150-74.402 0.003906c-32.398 0-58.801 26.398-58.801 58.801v33.602c0 32.398 26.398 58.801 58.801 58.801h20.398c-12 54-18 109.2-18 164.4v282c0 32.398 26.398 58.801 58.801 58.801h98.398c32.398 0 58.801-26.398 58.801-58.801v-90h588v90c0 32.398 26.398 58.801 58.801 58.801h98.398c32.398 0 58.801-26.398 58.801-58.801v-283.2c0-55.199-6-110.4-18-164.4h20.398c32.398 0 58.801-26.398 58.801-58.801v-33.602c-2.3984-31.199-28.797-57.598-61.199-57.598zm-844.8 60 56.398-175.2c9.6016-28.801 36-48 64.801-48h424.8c30 0 56.398 19.199 64.801 48l56.398 175.2c2.3984 8.3984-3.6016 15.602-12 15.602l-643.2-0.003906c-8.3984 1.1992-14.398-7.1992-12-15.598zm122.4 286.8h-118.8c-20.398 0-36-15.602-36-36v-56.398c0-21.602 20.398-39.602 42-36l110.4 18c14.398 2.3984 26.398 13.199 30 27.602l8.3984 38.398c4.8047 22.801-11.996 44.398-35.996 44.398zm576-36c0 20.398-15.602 36-36 36h-118.8c-22.801 0-39.602-21.602-34.801-43.199l8.3984-38.398c3.6016-14.398 14.398-25.199 30-27.602l110.4-18c21.602-3.6016 42 13.199 42 36l0.003906 55.199z"/>
               </svg>
              )}
              {item.symbol === 'chip' && (
                <svg className="h-[8px] w-[8px]" fill="white" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                <path d="m1117.3 552-202.08-201.84c-17.16-16.141-41.512-22.133-64.207-15.805-22.691 6.332-40.426 24.062-46.754 46.758-6.332 22.691-0.33594 47.043 15.801 64.207l154.32 154.68-154.32 153.72c-16.977 17-23.594 41.766-17.363 64.965 6.2344 23.203 24.371 41.32 47.582 47.523s47.965-0.44922 64.941-17.445l202.08-201.72c12.574-12.617 19.637-29.703 19.637-47.52 0-17.812-7.0625-34.902-19.637-47.52zm-737.4-201.84c-12.625-12.613-29.738-19.695-47.582-19.695s-34.957 7.082-47.578 19.695l-202.08 201.84c-12.609 12.625-19.695 29.738-19.695 47.578 0 17.844 7.0859 34.957 19.695 47.582l202.08 201.6c16.977 16.996 41.73 23.648 64.941 17.445s41.348-24.32 47.582-47.523c6.2305-23.199-0.38672-47.965-17.363-64.965l-154.32-153.72 154.32-154.68c12.609-12.625 19.691-29.738 19.691-47.582 0-17.84-7.082-34.957-19.691-47.578zm342.6-183.12c-16.855-6.0312-35.41-5.1484-51.621 2.4492-16.207 7.5977-28.754 21.297-34.898 38.113l-199.08 738.36c-5.8945 22.055-0.31641 45.594 14.848 62.656 15.164 17.062 37.887 25.363 60.48 22.102 22.594-3.2656 42.035-17.66 51.75-38.32l199.08-738.36c6.1797-16.914 5.3789-35.59-2.2305-51.914-7.6094-16.32-21.398-28.945-38.328-35.086z" fill-rule="evenodd"/>
               </svg>
              )}
              {item.symbol === 'heart' && (
                <svg className="h-[8px] w-[8px]" fill="white" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                <path d="m896.4 141.6c-228-45.602-296.4 181.2-296.4 181.2s-68.398-226.8-296.4-181.2c-206.4 42-252 276-178.8 422.4 58.801 120 262.8 259.2 475.2 500.4 212.4-241.2 416.4-380.4 476.4-500.4 73.203-146.4 26.402-380.4-180-422.4z"/>
               </svg>
              )}
          </div>
        )}
      </motion.div>
    </Tooltip>
  );

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="flex justify-between text-[9.5px] font-mono">
        <span className="w-[33%] text-left">実現済み</span>
        <span className="w-[33%] text-center text-accent">新興技術</span>
        <span className="w-[33%] text-right">SF</span>
      </div>
      <div className="relative w-full">
        <div className="flex justify-between">
          <div className="flex flex-wrap w-[33%] gap-[2px] justify-start">
            {technologies.map((item) =>
              getCurrentCategory(item) === 'established' && renderTechItem(item, 'established')
            )}
          </div>
          <div className="flex flex-wrap w-[33%] gap-[2px] justify-center">
            {technologies.map((item) =>
              getCurrentCategory(item) === 'emerging' && renderTechItem(item, 'emerging')
            )}
          </div>
          <div className="flex flex-wrap w-[33%] gap-[2px] justify-end">
            {technologies.map((item) =>
              getCurrentCategory(item) === 'speculative' && renderTechItem(item, 'speculative')
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyProgressionChart; 